import { useState } from 'react';
import type { FaqItem } from '@/mocks/faq';

interface Props {
  items: FaqItem[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: Props) {
  const [openIndex, setOpenIndex] = useState<number>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, i) => {
        const open = openIndex === i;
        return (
          <div key={i}>
            <button
              type="button"
              aria-expanded={open}
              onClick={() => setOpenIndex(open ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-secondary-100 text-xs font-bold text-secondary-800">
                  Q{i + 1}
                </span>
                <span className="font-display text-sm font-bold leading-6 text-foreground-950 md:text-base">
                  {item.q}
                </span>
              </span>
              <i
                className={`ri-add-line text-lg text-primary-600 transition-transform duration-300 ${open ? 'rotate-45' : ''}`}
                aria-hidden="true"
              ></i>
            </button>
            {open && (
              <div className="px-4 pb-5 md:px-5">
                <div className="ml-9 text-sm leading-7 text-foreground-700 md:text-[15px]">
                  <p>{item.a}</p>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}